// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CheckoutController from "./checkout_controller"
application.register("checkout", CheckoutController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import PopoversController from "./popovers_controller"
application.register("popovers", PopoversController)

import TicketsRequestController from "./tickets_request_controller"
application.register("tickets-request", TicketsRequestController)
